import React from "react";

export default function ClientInfoCard({ labels, client }) {
  const fields = [
    { key: "name", label: labels.nameLabel },
    { key: "email", label: labels.emailLabel },
    { key: "phone", label: labels.phoneLabel },
    { key: "property", label: labels.propertyLabel },
  ];

  return (
    <div className="card p-4">
      <p className="text-sm font-semibold text-slate-900">{labels.title}</p>
      <div className="mt-3 grid gap-3 md:grid-cols-2">
        {fields.map((field) => (
          <div key={field.key}>
            <p className="text-xs text-slate-400">{field.label}</p>
            <p className="mt-1 text-sm text-slate-700">
              {client[field.key] || labels.fallback}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
